var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoNoAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8748 28.3333V30C24.8748 32.7614 22.6922 35 19.9998 35C17.3075 35 15.1249 32.7614 15.1249 30V28.3333M24.8748 28.3333H15.1249M24.8748 28.3333H30.7085C31.3301 28.3333 31.6423 28.3333 31.894 28.2463C32.3748 28.0799 32.7526 27.6927 32.9148 27.1996C33 26.9405 33 26.6192 33 25.9766C33 25.6954 32.9997 25.5548 32.9782 25.4207C32.9377 25.1674 32.8411 24.9272 32.6951 24.7187C32.6179 24.6085 32.5199 24.5079 32.3266 24.3097L31.6936 23.6605C31.4894 23.451 31.3747 23.1669 31.3747 22.8707V16.6667C31.3747 10.2233 26.282 4.99998 19.9998 5C13.7177 5.00002 8.62498 10.2234 8.62498 16.6667V22.8707C8.62498 23.1669 8.51 23.451 8.30578 23.6605L7.67284 24.3097C7.47898 24.5085 7.38194 24.6084 7.30468 24.7187C7.15869 24.9273 7.06199 25.1674 7.02145 25.4207C7 25.5548 7 25.6954 7 25.9766C7 26.6192 7 26.9404 7.08523 27.1996C7.2474 27.6927 7.62449 28.0799 8.10527 28.2463C8.35697 28.3333 8.66887 28.3333 9.2905 28.3333H15.1249",
    stroke: "#242628",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15L22.7818 20.7818",
    stroke: "#242628",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.7818L22.7818 15",
    stroke: "#242628",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNoAlarm);
export default __webpack_public_path__ + "static/media/ico-noAlarm.964bf385b7ca29646f2f77979204613b.svg";
export { ForwardRef as ReactComponent };